/**
 * EditAccessoryNoteCtrl controller
 * Add/Edit Subscriber's note
 */

/**
 * EditAccessoryNoteCtrl controller
 *
 * @class EditAccessoryNoteCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:EditAccessoryNoteCtrl
 */
/* @ngInject */
export default function EditAccessoryNoteCtrl ($uibModalInstance, authSvc, viewMode, subscr, note) {
  var vm = this

  vm.viewMode = viewMode

  vm.noteTypes = ['Accessory Purchasing']

  /**
   * Note
   *
   * @memberof mwApp/subscribers.controller:EditAccessoryNoteCtrl
   * @type {models.Note}
   */
  vm.note = note
  vm.note.$accessories = vm.note.accessories.map(a => a.name)
  vm.note.$processed = vm.note.status === 'PROCESSED'

  vm.note.subscriber = subscr

  /**
   * isNew flag
   *
   * @memberof mwApp/subscribers.controller:EditAccessoryNoteCtrl
   * @type {Boolean}
   */
  vm.isNew = note._isNew()

  /**
   * Quill editor toolbar configuration
   * {@link http://quilljs.com/docs/modules/toolbar/}
   *
   * @memberof mwApp/subscribers.controller:EditAccessoryNoteCtrl
   * @type {Object}
   */
  vm.ngQuillToolbar = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link', 'image'],
      ['clean'] // remove formatting button
    ]
  }

  /**
   * Create or edit note, and close modal window afterwards
   *
   * @memberof mwApp/subscribers.controller:EditAccessoryNoteCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    note._trust()
      ._save()
      .then(
        () => {
          $uibModalInstance.close(note)
        }
      )
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/subscribers.controller:EditAccessoryNoteCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
